// src/redux/Slices/busOperatorsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchParams: {
    operatorName: '',
    operatorNumber: '',
    stateName: '',
    stateCode: '',
    zoneName: '',
    zoneCode: '',
  },
  operators: [],
  searchPerformed: false,
};

const busOperatorsSlice = createSlice({
  name: 'busOperators',
  initialState,
  reducers: {
    setSearchParams(state, action) {
      state.searchParams = action.payload;
    },
    setOperators(state, action) {
      state.operators = action.payload;
    },
    setSearchPerformed(state, action) {
      state.searchPerformed = action.payload;
    },
    resetOperatorsSearch() {
      return { ...initialState };
    },
  },
});

export const {
  setSearchParams,
  setOperators,
  setSearchPerformed,
  resetOperatorsSearch,
} = busOperatorsSlice.actions;

export default busOperatorsSlice.reducer;